export const MAX_RETRY_COUNT: number = 1;
